module.exports = __webpack_public_path__ + "img/SC-3-delat.b1e5e4e4.jpg";